import { render, staticRenderFns } from "./GraphElementNodeGroup.vue?vue&type=template&id=3f4f89fc&scoped=true&"
import script from "./GraphElementNodeGroup.vue?vue&type=script&lang=ts&"
export * from "./GraphElementNodeGroup.vue?vue&type=script&lang=ts&"
import style0 from "./icons.scss?vue&type=style&index=0&id=3f4f89fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4f89fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
